import { useQuery } from '@tanstack/react-query';
import { fetchDistrictSchools } from '../api/districtSchoolsApi';

/**
 * TanStack Query hook that loads the schools for a district. Disabled until
 * an orgRefId is available (e.g. from the `orgRefId` URL search param).
 *
 * Sample usage:
 * const { data, isLoading, isError } = useDistrictSchools(orgRefId);
 *
 * @param {string|null} orgRefId - District org reference ID
 * @returns {Object} Query state (data, isLoading, isError, error)
 */
const useDistrictSchools = orgRefId =>
  useQuery({
    queryKey: ['districtSchools', orgRefId],
    queryFn: () => fetchDistrictSchools({ orgRefId }),
    enabled: Boolean(orgRefId),
  });

export default useDistrictSchools;
